import type { TBucketKey } from '@crm/entities/deals-board'
import { ROUTES } from '@crm/shared/routes'

export const bucketRoutesByKey: Record<TBucketKey, string> = {
  postponed: ROUTES.POSTPONED_DEALS,
  lost: ROUTES.LOST_DEALS,
  in_work_or_finished: ROUTES.IN_WORK_OR_FINISHED_DEALS,
}
